import {
    Component,
    computed,
    EventEmitter,
    Input,
    OnInit,
    Output,
    signal
} from "@angular/core";
import { VisualizationOptionsType } from "@arch/_shared/types/options-visualization";
import { SharedMaterialModule } from "@shared/modules/shared-material.module";
import { CompanyEntity } from "@arch/domain/entity/company.entity";
import { BadgeRocketComponent } from "../../../../../../shared/components/badge-rocket/badge-rocket.component";

@Component({
    selector: "app-report-adjustments-navigation",
    imports: [SharedMaterialModule, BadgeRocketComponent],

    templateUrl: "./report-adjustments-navigation.component.html",
    styleUrl: "./report-adjustments-navigation.component.scss"
})
export class ReportAdjustmentsNavigationComponent {
    @Input({ required: true }) company: CompanyEntity;
    @Input({ required: false }) optionsNavigation: OptionsNavigationType = {
        period: true,
        comparation: true,
        analysisplus: true
    };
    @Input({ required: true }) set options(value: VisualizationOptionsType) {
        this.optionsSignal.set(value);
    }
    get options() {
        return this.optionsSignal();
    }
    private optionsSignal = signal<VisualizationOptionsType>({});
    @Output() onNavigateChange = new EventEmitter<NavigationItem>();

    public readonly navigationItems = computed((): NavigationItem[] => {
        const analisePlusContracted = this.company.analysisPlusStatus;
        const period = {
            label: "Período",
            icon: "fa-solid fa-calendar-days",
            description:
                "Escolha o período: mensal, trimestral, semestral ou anual.",
            page: 0
        };
        const comparation = {
            label: "Comparação",
            icon: "fa-solid fa-code-compare",
            description: "Compare os resultados com o período de sua escolha.",
            page: 1,
            disabled: !!this.options?.budget || !!this.options?.projection
        };
        const analysisplus = {
            label: "Análise Plus",
            icon: analisePlusContracted ? "fa-solid fa-bolt" : "",
            withOutIcon: true,
            image: analisePlusContracted
                ? "/images/stars-analysis-plus.svg"
                : "/images/analise-plus.png",
            description: "Analise, projete, orce e defina objetivos.",
            page: analisePlusContracted ? 2 : 3,
            contracted: analisePlusContracted
        };
        const options: NavigationItem[] = [];
        if (this.optionsNavigation.period) options.push(period);
        if (this.optionsNavigation.comparation) options.push(comparation);
        if (this.optionsNavigation.analysisplus) options.push(analysisplus);

        return options;
    });
}

type OptionsNavigationType = {
    period?: boolean;
    comparation?: boolean;
    analysisplus?: boolean;
};

type NavigationItem = {
    icon?: string;
    label: string;
    description: string;
    page: number;
    withOutIcon?: boolean;
    contracted?: boolean;
    image?: string;
    disabled?: boolean;
};
